import { OrderPendency } from '../types/apiResponse/orderPendency';

export const orderApprovalColor = (
  pendencies: Pick<OrderPendency, 'status'>[] = [],
): 'positive' | 'negative' | 'warning' => {
  if (pendencies.some((pendency) => pendency.status === 'rejected')) return 'negative';
  if (pendencies.some((pendency) => pendency.status === 'pending')) return 'warning';
  return 'positive';
};
